export default __webpack_public_path__ + "static/media/bell-icon.93924419.svg";